import React from 'react';
import Modal from "react-modal"
import NiceModal, { useModal } from "@ebay/nice-modal-react"

const TournamentRuleModel = ({ rules }) => {
    const modal = useModal()

    const closeTournamentRuleHandler = () => {
        modal.hide();
    }

    return (
        <Modal
            isOpen={modal.visible}
            ariaHideApp={false}
            className="mymodal"
            onRequestClose={modal.hide}
        >
            <div className="overflow-y-auto max-h-[600px] h-full flex w-[520px] p-[16px] flex-col gap-[16px] rounded-[32px] bg-[#F1F1F1] [box-shadow:0px_4px_16px_0px_rgba(0,_0,_0,_0.15)]">
                <div className="flex justify-center px-[16px] py-[6px] rounded-[16px] text-center">
                    <p className='text-[#000] text-center text-[28px] not-italic font-bold leading-[normal] tracking-[-1.12px]'>Rules</p>
                </div>
                <div className='w-full h-auto flex p-[24px] justify-center items-start gap-[24px] rounded-[16px] bg-[#FAFAFA]'>
                    <div className='w-full flex flex-col items-start gap-[8px]'>
                        <p className='text-[#000] text-[20px] not-italic font-semibold leading-[24px] tracking-[-1.2px]'>Compete to the finish line!</p>
                        <div className='w-full flex flex-col items-start gap-[4px]' dangerouslySetInnerHTML={{ __html: rules }} />
                    </div>
                </div>
                <div className="flex p-[16px] flex-col gap-[16px] rounded-[16px] bg-[#FFF]">
                    <button className="flex h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[39px] bg-[#000]" onClick={closeTournamentRuleHandler}>
                        <p className='text-[#FFF] text-[20px] not-italic font-bold leading-[25px] tracking-[-0.38px]'>Go back</p>
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default NiceModal.create(TournamentRuleModel);